/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_At_NowInputs */

const en_us2_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

const pt_br2_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const es_419_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora`)
};

const pt_pt2_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const fr_fr2_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenant`)
};

const de_de2_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt`)
};

const it_it2_workout_live_forgotten_at_now = /** @type {(inputs: Workout_Live_Forgotten_At_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adesso`)
};

/**
* | output |
* | --- |
* | "Now" |
*
* @param {Workout_Live_Forgotten_At_NowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_at_now = /** @type {((inputs?: Workout_Live_Forgotten_At_NowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_At_NowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_at_now(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_at_now(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_at_now(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_at_now(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_at_now(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_at_now(inputs)
	return en_us2_workout_live_forgotten_at_now(inputs)
});
export { workout_live_forgotten_at_now as "workout-live.forgotten_at_now" }